import { storiesOf } from '@storybook/react-native';
import { Icon } from 'pawtner-mobile-ui';
import React from 'react';
import { SafeAreaView, ScrollView, Text, View } from 'react-native';
import CenterView from './CenterView';

storiesOf('Icon', module)
  .addDecorator((getStory) => <CenterView>{getStory()}</CenterView>)
  .add('Default', () => (
    <SafeAreaView>
      <ScrollView contentContainerStyle={{ paddingVertical: 10 }}>
        <View
          style={{
            flex: 1,
            flexWrap: 'wrap',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            marginTop: '10%',
          }}
        >
          {Object.keys(Icon).map((iconName) => {
            const Component = Icon[iconName];
            return (
              <View
                style={{
                  margin: 10,
                  padding: 10,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexBasis: '25%',
                }}
              >
                <Component />
                <Text style={{ marginTop: 10 }}>{iconName}</Text>
              </View>
            );
          })}
        </View>
      </ScrollView>
    </SafeAreaView>
  ))
  .add('Icon with custom size', () => (
    <Icon.Cat width={100} height={100} color='red' />
  ));
